export const encodeOutreachParams = (params = {}) => encodeURIComponent(JSON.stringify(params));
export const decodeOutreachParams = (paramsString = '') =>
  JSON.parse(decodeURIComponent(paramsString));

const formatDate = (dateInMs) => {
  const date = new Date(dateInMs);
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};

const getTimeUnits = (diffInMinutes) => {
  if (diffInMinutes < 1) return { value: 0, unit: 'now' };
  if (diffInMinutes < 60) return { value: diffInMinutes, unit: 'min' };

  const hours = Math.floor(diffInMinutes / 60);
  if (hours < 24) return { value: hours, unit: 'h' };

  const days = Math.floor(hours / 24);
  return { value: days, unit: 'd' };
};

export const getOutreachMessageDisplayTime = (dateInMs, currentTimeInMs) => {
  if (!dateInMs) return '';

  const diffInMinutes = Math.floor((currentTimeInMs - dateInMs) / 60000);
  const { value, unit } = getTimeUnits(diffInMinutes);

  if (unit === 'now') return 'now';
  if (unit === 'd' && value >= 8) return formatDate(dateInMs);

  return `${value} ${unit}`;
};

export const getCompanyNewsDisplayTime = (dateInMs, currentTimeInMs) => {
  if (!dateInMs) return '';

  const diffInMinutes = Math.floor((currentTimeInMs - dateInMs) / 60000);
  const { value, unit } = getTimeUnits(diffInMinutes);

  if (unit === 'now') return 'now';
  if (unit === 'd' && value >= 8) return formatDate(dateInMs);

  const pluralUnit = unit === 'min' ? 'minute' : unit === 'h' ? 'hour' : 'day';
  const suffix = value === 1 ? pluralUnit : `${pluralUnit}s`;

  return `${value} ${suffix} ago`;
};
